<template>
  <div class="home-section margin-top_32">
    <div class="section-title">
      <span
        v-for="item in unitClassList"
        :key="item.id"
        :class="item.id === current ? 'span-active' : 'span-default'"
        @click="handleTitle(item.id)"
      >
        {{ item.classifyName }}
      </span>
    </div>
    <div class="section-swiper">
      <el-carousel
        arrow="always"
        trigger="click"
        autoplay
        :interval="5000"
        height="180px"
      >
        <el-carousel-item
          v-for="index in Math.ceil(unitList.length / 4)"
          :key="index"
        >
          <div class="swiper-item">
            <div
              v-for="(sub, subInd) in unitList.slice(
                (index - 1) * 4,
                index * 4
              )"
              :key="sub.unitName + subInd"
              @click="handleItem(sub)"
            >
              <a v-if="sub.urlLink" target="_blank" :href="sub.urlLink">
                <img :src="sub.unitPropagateUrl" :alt="sub.unitName" />
              </a>
              <img v-else :src="sub.unitPropagateUrl" :alt="sub.unitName" />
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
import * as API from '../../../api/home/index'
export default {
  name: 'HomeSection6',
  data() {
    return {
      current: 0,
      unitClassList: [],
      unitList: []
    }
  },
  created() {
    this.getUnitClassList()
  },
  methods: {
    async getUnitClassList() {
      try {
        const res = await API.getUnitClassList()
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          const _id = records[0]?.id
          this.unitClassList = records
          this.current = _id
          if (_id) this.getUnitClassToUnitList(_id)
        }
      } catch (error) {}
    },
    async getUnitClassToUnitList(classifyId) {
      try {
        const res = await API.getUnitClassToUnitList({ classifyId, limit: 999 })
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.unitList = records
        } else {
          this.unitList = []
        }
      } catch (error) {}
    },
    handleTitle(id) {
      this.current = id
      this.getUnitClassToUnitList(id)
    },
    // handlejoin() {
    //   this.$router.push('/cooperationApply')
    // },
    handleItem() {}
  }
}
</script>
<style lang='scss' scoped>
.home-section {
  width: 100%;
  height: 254px;
  box-sizing: border-box;
  padding: 24px;
  background: linear-gradient( 180deg, #DFEDFF 0%, #FFFFFF 100%, #FFFFFF 100%);
  .section-title {
    font-size: 20px;
    color: #9C9C9C;
    span {
      line-height: 30px;
      font-weight: 400;
      & + span {
        margin-left: 32px;
      }
    }
    .span-active {
      font-weight: 600;
      color: #2F2F2F;
    }
  }
  .section-swiper {
    width: 100%;
    .swiper-item {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 auto;
      > div {
        width: 270px;
        height: 103px;
        // background: #ffffff;
        box-shadow: 0px 0px 3px 2px #f2f2f2;
        margin: 0 5px;
        a {
          width: 100%;
          height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
<style lang='scss'>
.section-swiper {
  .el-carousel__indicators {
    display: none;
  }
}
</style>
